export const selectDeviceConfigSchemas = (state, deviceId) => {
    return state.deviceConfigSchemas.schemasByDeviceId[deviceId];
};
